import { Components, tableCellClasses } from '@mui/material';
import { Theme } from '@mui/material/styles';

export const MuiTableRow: Components<Theme>['MuiTableRow'] = {
  styleOverrides: {
    root: ({ theme, ownerState }) => ({
      ...(ownerState.className !== 'stripe-disabled' && {
        backgroundColor: theme.palette.background.default,
        [`&:nth-child(odd) > .${tableCellClasses.body}`]: {
          backgroundColor: theme.palette.neutral.lighter,
        },
        [`&:last-child > .${tableCellClasses.body}`]: {
          border: 'none',
        },
      }),
      cursor: 'pointer',
    }),
  },
};

export const MuiTableCell: Components<Theme>['MuiTableCell'] = {
  styleOverrides: {
    root: ({ ownerState, theme }) => ({
      ...(ownerState.variant === 'head' && {
        height: 32,
        backgroundColor: theme.palette.background.default,
        color: `${theme.palette.neutral.main}`,
      }),
    }),
  },
};
